import React, { useCallback, useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import _ from 'underscore';
import ReactTooltip from 'react-tooltip';
import InfiniteScroll from 'react-infinite-scroll-component';
import useGym from 'helpers/use_gym';
import Select from 'react/components/select';
import { useExtendState } from 'helpers/use_extend_state';
import api from 'helpers/api';
import { useAngularService } from 'helpers/get_angular_service';
import classNames from 'classnames';
import LogEntryContent from 'react/components/log_entry_content';
import useOnMount from 'helpers/use_on_mount';
import Tooltip from 'react/components/tooltip';

const ContactActivity = ({ contact }) => {
  const ActivityService = useAngularService('ActivityService');
  const $rootScope = useAngularService('$rootScope');
  const gym = useGym();
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [filters, updateFilters] = useExtendState<any>({});
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsMeta, setItemsMeta] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      ReactTooltip.rebuild();
    }, 100);
  }, [items]);

  const grouppedActivity = useMemo(() => {
    const thisMonth = moment().format('MMMM YYYY');
    return _.chain(items)
      .map((item) => {
        const month = moment(item.created_at).format('MMMM YYYY');
        item.month = month === thisMonth ? 'This Month' : month;
        return item;
      })
      .groupBy('month')
      .pairs()
      .sortBy((item) => {
        return item[1][0].created_at;
      })
      .value()
      .reverse();
  }, [items]);

  const getItems = useCallback(
    (page) => {
      setLoading(true);

      const url = `/gyms/${gym.id}/contacts/${contact.id}/contact_log_entries`;
      api.get(url, { page, 'types[]': filters.types || undefined }).then(
        (data) => {
          setCurrentPage(page);
          setLoading(false);
          if (page === 1) {
            setItems(data);
          } else {
            setItems((items) => items.concat(data));
          }
          setItemsMeta(data.meta);
        },
        () => {
          setLoading(false);
        },
      );
    },
    [contact.id, filters, gym.id],
  );

  useEffect(() => {
    getItems(1);
  }, [getItems]);

  useOnMount(() => {
    const unsubscribe = $rootScope.$on('contact:activity:reload', () => getItems(1));
    return unsubscribe;
  });

  const loadMoreBookings = () => {
    getItems(currentPage + 1);
  };

  return (
    <div>
      <Tooltip type="light" />
      <div className="pull-right">
        <Select
          value={filters.types}
          options={contact.activity_filter_types}
          getValue={(item) => item[0]}
          getLabel={(item) => item[1]}
          onChange={(types) => updateFilters({ types })}
          emptyLabel="All activities"
          allowEmptyOption
          variant="v2"
          size="sm"
        ></Select>
      </div>

      <h3>Activity</h3>

      <InfiniteScroll
        dataLength={items.length}
        next={loadMoreBookings}
        hasMore={!loading && itemsMeta && itemsMeta.total > items.length}
        loader={null}
      >
        <ul className="activity-feed">
          {grouppedActivity.map((group) => (
            <div key={group[0]}>
              <li className="activity-group">{group[0]}</li>
              {group[1].map((event) => (
                <li className="activity-item" key={event.id}>
                  <time className="activity-timestamp pull-right">
                    <i>{event.formatted_created_at}</i>
                  </time>
                  <span
                    className={classNames('activity-type', ActivityService.getIconClass(event))}
                  />

                  <LogEntryContent item={event} messageMaxHeight={140} />
                </li>
              ))}
            </div>
          ))}
          {!items.length && !loading && <li>No activities found.</li>}
          {loading && <li>Loading...</li>}
        </ul>
      </InfiniteScroll>
    </div>
  );
};

export default ContactActivity;
